import { useContext } from 'react';
import { ChangelogContext } from '../contexts/ChangelogContext';

export const useChangelog = (): string => {
  const { changelog } = useContext(ChangelogContext);

  return changelog;
};
